import { render, staticRenderFns } from "./enTouchDetail.vue?vue&type=template&id=e74b7328&scoped=true&"
import script from "./enTouchDetail.vue?vue&type=script&lang=js&"
export * from "./enTouchDetail.vue?vue&type=script&lang=js&"
import style0 from "./enTouchDetail.vue?vue&type=style&index=0&id=e74b7328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74b7328",
  null
  
)

export default component.exports